import React, { useMemo } from "react";
import { groupByAlertId } from "../utils/alerts";
import { getDateString, getRelativeTimeString, getTimeString } from "../utils/date";

const makeDataForHistory = (data) => {
  const groupedAlerts = groupByAlertId(data);

  const historyData_ = [];
  Object.entries(groupedAlerts).forEach(([id, alerts]) => {
    const titles = new Set();
    const cities = new Set();
    const threats = new Set();

    let endDate = alerts[alerts.length - 1].date;
    alerts.forEach((alert) => {
      threats.add(alert.threat);

      alert.cities.forEach((city) => {
        cities.add(city.name);
        titles.add(city.areaName);
      });

      if (alert.date.getTime() > endDate.getTime()) endDate = alert.date;
    });

    historyData_.push({
      start: alerts[0].date,
      end: endDate,
      threats: Array.from(threats),
      areas: Array.from(titles),
      cities: Array.from(cities),
      alertId: alerts[0].alertId,
    });
  });

  return historyData_.reverse();
};

const History = ({ data }) => {
  const historyData = useMemo(() => makeDataForHistory(data), [data]);
  return (
    <div>
      {historyData?.map((item) => (
        <a href={`https://www.tzevaadom.co.il/alerts/${item.alertId}`} target="_blank _noreferrer">
          <div className="flex  mt-2 bg-[#fdfdfd] rounded-[7px] overflow-auto cursor-pointer justify-between">
            <div className="flex-grow-0 w-[95%] p-[8px] px-2">
              <p className="font-bold text-md leading-[1]">{item.areas.join(", ")}</p>
              <p className="text-[#d50f02] mt-[2px] text-sm ">
                {getRelativeTimeString(item.end)} | {Array.from(new Set([getDateString(item.end, true), getDateString(item.start, true)])).join(" - ")} (
                {Array.from(new Set([getTimeString(item.end, true), getTimeString(item.start, true)])).join(" - ")})
              </p>
              <p className="text-[#383838] text-base leading-[1] mt-[1px]">{item.cities.join(", ")}</p>
            </div>
            <div className="flex flex-col py-[5px] bg-[#d50f02] w-[45px] items-center justify-center">
              {item.threats.map((t) => (
                <img alt={t} className="w-[20px] my-[10px]" src={`/static/images/threat${t}.${t === 0 ? "png" : "svg"}`} />
              ))}
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default History;
